import React, {useEffect, useState} from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import firebaseInit from 'firebase-init';
import {scenariosData} from 'data/scenarios-data';
import AdminLogin from './admin/admin-login';
import SelectGame from './select-game/select-game';
import GameController from './game/game-controller';
import Background from './ui/background/background';
import './app.scss';

const App = () => {
	/* Current background */
	const [currentBackground, setCurrentBackground] = useState({backgroundId: null, scenarioId: null});

	/**
	 * Component mounted
	 */
	 useEffect(() => {
		/* Component mounted */

		/* Initialize firebase */
		firebaseInit();
	});


	/**
	 * Update background
	 * @param {string} newBackground 
	 * @param {string} scenarioId 
	 */
	const updateBackground = (newBackground, scenarioId) => {
		setCurrentBackground({backgroundId: newBackground, scenarioId});
	};

		
	return (
		<div className="App">
			{currentBackground.backgroundId &&
				<Background background={currentBackground}/>
			}
			<Router>
				<Routes>
					<Route 
						path={'/admin'}
						element={<AdminLogin 
							updateBackground={updateBackground} 
						/>}
					/>
					<Route 
						path={'/' + scenariosData.game1.url}
						element={<GameController 
							scenarioId="game1" 
							updateBackground={updateBackground} 
						/>}
					/>
					<Route 
						path={'/' + scenariosData.game2.url}
						element={<GameController 
							scenarioId="game2" 
							updateBackground={updateBackground} 
						/>}
					/>
					<Route 
						path="*" 
						element={<SelectGame />}					
					/>
				</Routes>
			</Router>
		</div>
	);
};

export default App;
